import { generatePath } from 'react-router-dom';

export const ROOT_PATH = '/';
export const BASE_PROJECT_PATH = `/projects/:projectId`;
export const BASE_HASH_PATH = '/account#';
export const PROJECT_PATH = `${BASE_HASH_PATH}/projects/:projectId`;
export const INBOX_PATH = `${PROJECT_PATH}/inbox`;
export const PROJECT_REPORTS_PATH = `${PROJECT_PATH}/reports`;
export const PROJECT_CONVERSATIONS_PATH = `${PROJECT_PATH}/conversations`;
export const PROJECT_PROCESSES_WORKSTREAMS_PATH = `${PROJECT_PATH}/processes/workstreams`;
export const PROJECT_PROCESSES_WORKSTREAMS_WORKSTREAM_PATH = `${PROJECT_PATH}/processes/workstreams/:workstreamId`;
export const PROJECT_PROCESSES_TASKS_PATH = `${PROJECT_PATH}/processes/tasks`;
export const EMAI_ENTRY_PATH = `/${BASE_HASH_PATH}/projects/:projectId/email/:emailId`;
export const INBOX_ENTRY_PATH = `${INBOX_PATH}:id`;
export const NOTIFICATION_PATH = ``;

export const generateRoutePath = (path, params, qs = {}) => {
  const url = generatePath(path, params);

  return Object.keys(qs).length
    ? `${url}?${new URLSearchParams(qs).toString()}`
    : url;
};
